module.exports = __webpack_public_path__ + "static/media/project_img_001.c18130cd.jpg";